import { useQuery } from 'react-query';
import qs from 'qs';

import { axios } from 'lib/axios';

const LIMIT = 10;

export const getCompanyApplications = async ({ scope, search, adID, buyerID, supplierID, page }) => {
  const queryString = qs.stringify(
    {
      scope,
      search,
      ad_id: adID,
      buyer_id: buyerID,
      supplier_id: supplierID,
      offset: page * LIMIT,
      limit: LIMIT,
    },
    { skipNulls: true }
  );

  const { data } = await axios.get(`/api/job_ads/applications?${queryString}`);

  return data;
};

export const useCompanyApplications = ({ queryOptions = {}, ...params }) => {
  return useQuery(['company-applications', params], () => getCompanyApplications(params), {
    select: ({ data, total }) => ({ applications: data ?? [], total }),
    initialData: { data: [], total: 0 },
    keepPreviousData: true,
    ...queryOptions,
  });
};
